// Role definitions and access-control map for VérticePro.
//
// Two roles:
//   - "admin"     → full access to every module.
//   - "asistente" → data-entry only: Asistencia, Incapacidades, Rebajos, Bonificaciones, Solicitudes.
//                   Also sees a reduced Dashboard focused on their modules.
// Legacy value "user" (from early registrations / Google OAuth defaults) is normalized to "asistente"
// on the client side (least privilege).

export const ROLE_ADMIN = "admin";
export const ROLE_SUPER_ADMIN = "super_admin";
export const ROLE_ASISTENTE = "asistente";

// Routes an "asistente" can access.
const ASISTENTE_ROUTES = new Set([
  "/dashboard",
  "/asistencia",
  "/incapacidades",
  "/rebajos",
  "/bonificaciones",
  "/solicitudes",
  "/reportes",
]);

export function normalizeRole(raw) {
  if (raw === ROLE_SUPER_ADMIN) return ROLE_SUPER_ADMIN;
  if (raw === ROLE_ADMIN) return ROLE_ADMIN;
  return ROLE_ASISTENTE;
}

// Devuelve true tanto para admin como super_admin. Usar cuando la UI necesita
// gate por "capacidades de administrador" (dashboard admin, ver otros perfiles,
// etc.), no cuando se necesita distinguir super_admin específicamente.
export function isAdminRole(role) {
  const r = normalizeRole(role);
  return r === ROLE_ADMIN || r === ROLE_SUPER_ADMIN;
}

export function canAccessRoute(role, path) {
  const r = normalizeRole(role);
  if (r === ROLE_SUPER_ADMIN) return true;
  if (r === ROLE_ADMIN) {
    // Admin regular NO puede acceder al panel de super-administración.
    const clean = (path || "").split("?")[0].split("#")[0];
    if (clean.startsWith("/admin")) return false;
    return true;
  }
  // Match by path prefix (e.g. /asistencia?tab=1 → /asistencia).
  const clean = (path || "").split("?")[0].split("#")[0];
  return ASISTENTE_ROUTES.has(clean);
}

export function firstAllowedRoute(role) {
  return normalizeRole(role) === ROLE_ADMIN ? "/dashboard" : "/dashboard";
}
